import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const PermCtx = createContext(null);

export function PermProvider({ children }) {
  const { user } = useAuth();
  const [perms, setPerms] = useState(null);

  useEffect(() => {
    if (!user) { setPerms(null); return; }
    api.get("/me/menu").then((r) => setPerms(r.data)).catch(() => setPerms({ role: user.role, permissions: {}, modules: [] }));
  }, [user]);

  const value = useMemo(() => {
    const can = (module, action = "view") => {
      if (!perms) return false;
      if (perms.role === "super_admin" || perms.role === "platform_admin") return true;
      const acts = perms.permissions?.[module] || [];
      return acts.includes(action);
    };
    return { perms, can };
  }, [perms]);

  return <PermCtx.Provider value={value}>{children}</PermCtx.Provider>;
}

export const usePerms = () => useContext(PermCtx) || { perms: null, can: () => false };
